import {FC, FormEvent, useEffect, useState} from 'react';

import {ExternalLink} from '@atoms';

import {Button, FullWidthSpace, Input, Text} from '@custom-antd';

import {useModal} from '@modal/hooks';

import {useApiEndpoint, useUpdateApiEndpoint} from '@services/apiEndpoint';

import Colors from '@styles/Colors';

import {externalLinks} from '@utils/externalLinks';

import notificationCall from '../Notification/Notification';

import {StyledSearchUrlForm} from './EndpointModal.styled';

const EndpointModal: FC = () => {
  const {close} = useModal();

  const currentApiEndpoint = useApiEndpoint();
  const updateApiEndpoint = useUpdateApiEndpoint();

  const [value, setValue] = useState(currentApiEndpoint || '');
  const [isLoading, setLoading] = useState(false);

  const updateEndpoint = async (event: FormEvent) => {
    event.preventDefault();

    setLoading(true);
    try {
      await updateApiEndpoint(value);
      close();
    } catch (error) {
      notificationCall('failed', 'Could not receive data from the specified API endpoint');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setValue(currentApiEndpoint || '');
  }, [currentApiEndpoint]);

  return (
    <StyledSearchUrlForm onSubmit={updateEndpoint}>
      <Text>
        We could not detect the right Testkube API endpoint for you. Please enter the API endpoint for your installation
        (e.g. from the output of the Testkube installer)&nbsp;
        <ExternalLink href={externalLinks.apiEndpoint}>Learn more...</ExternalLink>
      </Text>
      <FullWidthSpace size={12}>
        <Input
          id="url"
          name="url"
          onChange={event => {
            setValue(event.target.value);
          }}
          value={value}
          width="550px"
          data-test="endpoint-modal-input"
          placeholder="e.g.: https://my.domain/results/v1"
        />
        <Button
          type="primary"
          htmlType="submit"
          disabled={isLoading}
          loading={isLoading}
          data-test="endpoint-modal-get-button"
        >
          Save
        </Button>
      </FullWidthSpace>
      <Text color={Colors.slate400} className="regular middle" style={{width: '100%'}}>
        Please make sure the endpoint is accessible from your browser.
      </Text>
    </StyledSearchUrlForm>
  );
};

export default EndpointModal;
